import * as React from 'react';
import {
  TRequestResetPassword,
  TRequestResetPasswordFormValues,
} from './RequestResetPassword.types';
import './RequestResetPassword.styles.scss';
import { REQUEST_RESET_PASSWORD_FORM_DEFAULT_VALUES } from './RequestResetPassword.constants';
import { yupResolver } from '@hookform/resolvers/yup';
import { requestResetPasswordSchema } from './RequestResetPassword.schema';
import { Controller, Resolver, useForm } from 'react-hook-form';
import { Button, TextInput } from 'components';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { useAppDispatch, useAppSelector } from 'store/store';
import { requestResetPasswordAsyncThunk } from 'store/users/users.action';

export const RequestResetPassword: TRequestResetPassword = () => {
  const localize = useLocalize();
  const dispatch = useAppDispatch();

  const { isLoading: isRequestResetPasswordLoading } = useAppSelector(
    (state) => state.users.requestResetPassword
  );

  const { control, handleSubmit } = useForm<TRequestResetPasswordFormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: REQUEST_RESET_PASSWORD_FORM_DEFAULT_VALUES,
    resolver: yupResolver(
      requestResetPasswordSchema
    ) as Resolver<TRequestResetPasswordFormValues>,
  });

  const onSubmit = (data: TRequestResetPasswordFormValues) => {
    dispatch(requestResetPasswordAsyncThunk(data));
  };

  return (
    <div className="request-reset-password">
      <div className="request-reset-password__container">
        <form
          className="request-reset-password__container__form"
          noValidate
          onSubmit={handleSubmit(onSubmit)}
        >
          <h4>{localize('requestresetpassword.form.title') as string}</h4>
          <div className="request-reset-password__container__form__input">
            <Controller
              control={control}
              name="email"
              render={({ field, fieldState }) => (
                <TextInput
                  {...field}
                  fullWidth
                  label={localize('requestresetpassword.form.email.label')}
                  placeholder={
                    localize(
                      'requestresetpassword.form.email.placeholder'
                    ) as string
                  }
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                />
              )}
            />
          </div>
          <div className="request-reset-password__container__form__button">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isRequestResetPasswordLoading}
              fullWidth
            >
              {localize('requestresetpassword.form.button.submit') as string}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
